import { c as _c } from "react/compiler-runtime";
import { useContext, useState } from 'react';
import useSWR from 'swr';
import APIMethodKeys from '../../../client/APIMethodKeys';
import { GlobalContext } from '../../contexts/GlobalContext';
import { StyledCardSection } from '../base/Card';
import { IconName } from '../base/Icon';
import Tabs from '../base/Tabs';
import Dropdown from '../Dropdown';
import ErrorBoundary from '../helpers/ErrorBoundary';
import BulkOperationHistory from './BulkOperationHistory';
import SubmitBulkOperation from './SubmitBulkOperation';
import { BulkOperationFilters, BulkOperationModel, BulkOperationType } from './types';
import { BULK_OPERATION_CONFIGS, ensureDateFilters, getApiMethod, getOperationLabels } from './utils';
interface DropdownContentProps {
  operation_type: BulkOperationType;
  model?: BulkOperationModel;
  filters: BulkOperationFilters;
  onSubmit?: () => void;
  filterHistory?: boolean;
}
const DropdownContent: React.FC<DropdownContentProps> = t0 => {
  const $ = _c(92);
  const {
    operation_type,
    model,
    filters: filtersProp,
    onSubmit: onSubmitProp,
    filterHistory
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const [active_tab, setActiveTab] = useState(operation_type);
  const config = BULK_OPERATION_CONFIGS[operation_type];
  let t1;
  if ($[0] !== model || $[1] !== operation_type) {
    t1 = getOperationLabels(operation_type, model);
    $[0] = model;
    $[1] = operation_type;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const labels = t1;
  let api_method;
  let filters;
  let getApiMethodKey;
  let t2;
  let t3;
  if ($[3] !== config.count_api_key || $[4] !== filterHistory || $[5] !== filtersProp || $[6] !== model || $[7] !== operation_type) {
    filters = ensureDateFilters(filtersProp);
    let t4;
    if ($[13] !== model || $[14] !== operation_type) {
      t4 = getApiMethod(operation_type, model);
      $[13] = model;
      $[14] = operation_type;
      $[15] = t4;
    } else {
      t4 = $[15];
    }
    api_method = t4;
    let t5;
    if ($[16] !== api_method || $[17] !== config.count_api_key || $[18] !== operation_type) {
      t5 = () => {
        if (operation_type === "cancel") {
          return APIMethodKeys.bulk.cancelEvents;
        }
        return APIMethodKeys[config.count_api_key][api_method];
      };
      $[16] = api_method;
      $[17] = config.count_api_key;
      $[18] = operation_type;
      $[19] = t5;
    } else {
      t5 = $[19];
    }
    getApiMethodKey = t5;
    t2 = useSWR;
    t3 = operation_type === "cancel" ? APIMethodKeys.bulk.cancelEvents.list({
      in_progress: true,
      ...(filterHistory ? {
        query: filters
      } : {})
    }) : getApiMethodKey().count({
      in_progress: true,
      ...(filterHistory ? {
        query: filters
      } : {})
    });
    $[3] = config.count_api_key;
    $[4] = filterHistory;
    $[5] = filtersProp;
    $[6] = model;
    $[7] = operation_type;
    $[8] = api_method;
    $[9] = filters;
    $[10] = getApiMethodKey;
    $[11] = t2;
    $[12] = t3;
  } else {
    api_method = $[8];
    filters = $[9];
    getApiMethodKey = $[10];
    t2 = $[11];
    t3 = $[12];
  }
  let t4;
  if ($[20] !== HookdeckAPI || $[21] !== api_method || $[22] !== config.count_api_key || $[23] !== filterHistory || $[24] !== filters || $[25] !== operation_type) {
    t4 = () => {
      let api_call;
      if (operation_type === "cancel") {
        api_call = HookdeckAPI.bulk.cancelEvents.list({
          in_progress: true,
          ...(filterHistory ? {
            query: filters
          } : {})
        });
      } else {
        api_call = HookdeckAPI[config.count_api_key][api_method].count({
          in_progress: true,
          ...(filterHistory ? {
            query: filters
          } : {})
        });
      }
      if (operation_type === "cancel") {
        return api_call.then(_temp2);
      }
      return api_call;
    };
    $[20] = HookdeckAPI;
    $[21] = api_method;
    $[22] = config.count_api_key;
    $[23] = filterHistory;
    $[24] = filters;
    $[25] = operation_type;
    $[26] = t4;
  } else {
    t4 = $[26];
  }
  const {
    data: ongoing_count,
    mutate: mutateOngoingCount
  } = t2(t3, t4);
  let t5;
  if ($[27] !== filterHistory || $[28] !== filters || $[29] !== getApiMethodKey || $[30] !== operation_type) {
    t5 = operation_type === "cancel" ? APIMethodKeys.bulk.cancelEvents.list({
      in_progress: false,
      ...(filterHistory ? {
        query: filters
      } : {})
    }) : getApiMethodKey().count({
      in_progress: false,
      ...(filterHistory ? {
        query: filters
      } : {})
    });
    $[27] = filterHistory;
    $[28] = filters;
    $[29] = getApiMethodKey;
    $[30] = operation_type;
    $[31] = t5;
  } else {
    t5 = $[31];
  }
  let t6;
  if ($[32] !== HookdeckAPI || $[33] !== api_method || $[34] !== config.count_api_key || $[35] !== filterHistory || $[36] !== filters || $[37] !== operation_type) {
    t6 = () => {
      let api_call_0;
      if (operation_type === "cancel") {
        api_call_0 = HookdeckAPI.bulk.cancelEvents.list({
          in_progress: false,
          ...(filterHistory ? {
            query: filters
          } : {})
        });
      } else {
        api_call_0 = HookdeckAPI[config.count_api_key][api_method].count({
          in_progress: false,
          ...(filterHistory ? {
            query: filters
          } : {})
        });
      }
      if (operation_type === "cancel") {
        return api_call_0.then(_temp4);
      }
      return api_call_0;
    };
    $[32] = HookdeckAPI;
    $[33] = api_method;
    $[34] = config.count_api_key;
    $[35] = filterHistory;
    $[36] = filters;
    $[37] = operation_type;
    $[38] = t6;
  } else {
    t6 = $[38];
  }
  const {
    data: history_count,
    mutate: mutateHistoryCount
  } = useSWR(t5, t6);
  let t7;
  if ($[39] !== mutateHistoryCount || $[40] !== mutateOngoingCount) {
    t7 = () => {
      mutateOngoingCount();
      mutateHistoryCount();
    };
    $[39] = mutateHistoryCount;
    $[40] = mutateOngoingCount;
    $[41] = t7;
  } else {
    t7 = $[41];
  }
  const revalidateCounts = t7;
  let t8;
  if ($[42] !== active_tab || $[43] !== onSubmitProp || $[44] !== operation_type || $[45] !== revalidateCounts) {
    t8 = () => {
      onSubmitProp?.();
      revalidateCounts();
      if (active_tab === operation_type) {
        setActiveTab("ongoing");
      }
    };
    $[42] = active_tab;
    $[43] = onSubmitProp;
    $[44] = operation_type;
    $[45] = revalidateCounts;
    $[46] = t8;
  } else {
    t8 = $[46];
  }
  const onSubmit = t8;
  let t9;
  if ($[47] !== labels.conditions_label || $[48] !== operation_type) {
    t9 = {
      label: labels.conditions_label,
      key: operation_type,
      icon: "checklist" as IconName
    };
    $[47] = labels.conditions_label;
    $[48] = operation_type;
    $[49] = t9;
  } else {
    t9 = $[49];
  }
  const t10 = config.icon as IconName;
  const t11 = ongoing_count?.count;
  const t12 = ongoing_count && ongoing_count.count > 0 ? "primary" as const : "muted" as const;
  let t13;
  if ($[50] !== labels.ongoing_label || $[51] !== t10 || $[52] !== t11 || $[53] !== t12) {
    t13 = {
      label: labels.ongoing_label,
      key: "ongoing",
      icon: t10,
      badge_label: t11,
      badge_theme: t12
    };
    $[50] = labels.ongoing_label;
    $[51] = t10;
    $[52] = t11;
    $[53] = t12;
    $[54] = t13;
  } else {
    t13 = $[54];
  }
  const t14 = history_count?.count;
  let t15;
  if ($[55] !== labels.history_label || $[56] !== t14) {
    t15 = {
      label: labels.history_label,
      key: "history",
      icon: "history" as IconName,
      badge_label: t14,
      badge_theme: "muted" as const
    };
    $[55] = labels.history_label;
    $[56] = t14;
    $[57] = t15;
  } else {
    t15 = $[57];
  }
  let t16;
  if ($[58] !== t13 || $[59] !== t15 || $[60] !== t9) {
    t16 = [t9, t13, t15];
    $[58] = t13;
    $[59] = t15;
    $[60] = t9;
    $[61] = t16;
  } else {
    t16 = $[61];
  }
  const tabs = t16;
  let t17;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      x: 4,
      t: 3
    };
    $[62] = t17;
  } else {
    t17 = $[62];
  }
  let t18;
  if ($[63] !== active_tab || $[64] !== tabs) {
    t18 = <StyledCardSection><Tabs onTabSelected={setActiveTab} active_tab={active_tab} border={false} p={t17} tabs={tabs} /></StyledCardSection>;
    $[63] = active_tab;
    $[64] = tabs;
    $[65] = t18;
  } else {
    t18 = $[65];
  }
  let t19;
  if ($[66] !== active_tab || $[67] !== filters || $[68] !== model || $[69] !== onSubmit || $[70] !== operation_type || $[71] !== revalidateCounts) {
    t19 = active_tab === operation_type && <SubmitBulkOperation operation_type={operation_type} model={model} onSubmit={onSubmit} revalidateCounts={revalidateCounts} query={filters} />;
    $[66] = active_tab;
    $[67] = filters;
    $[68] = model;
    $[69] = onSubmit;
    $[70] = operation_type;
    $[71] = revalidateCounts;
    $[72] = t19;
  } else {
    t19 = $[72];
  }
  let t20;
  if ($[73] !== active_tab || $[74] !== filterHistory || $[75] !== filters || $[76] !== model || $[77] !== operation_type || $[78] !== revalidateCounts) {
    t20 = active_tab === "ongoing" && <BulkOperationHistory operation_type={operation_type} model={model} revalidateCounts={revalidateCounts} filters={{
      in_progress: true,
      ...(filterHistory ? {
        query: filters
      } : {})
    }} />;
    $[73] = active_tab;
    $[74] = filterHistory;
    $[75] = filters;
    $[76] = model;
    $[77] = operation_type;
    $[78] = revalidateCounts;
    $[79] = t20;
  } else {
    t20 = $[79];
  }
  let t21;
  if ($[80] !== active_tab || $[81] !== filterHistory || $[82] !== filters || $[83] !== model || $[84] !== operation_type || $[85] !== revalidateCounts) {
    t21 = active_tab === "history" && <BulkOperationHistory operation_type={operation_type} model={model} revalidateCounts={revalidateCounts} filters={filterHistory ? {
      query: filters
    } : {}} />;
    $[80] = active_tab;
    $[81] = filterHistory;
    $[82] = filters;
    $[83] = model;
    $[84] = operation_type;
    $[85] = revalidateCounts;
    $[86] = t21;
  } else {
    t21 = $[86];
  }
  let t22;
  if ($[87] !== t18 || $[88] !== t19 || $[89] !== t20 || $[90] !== t21) {
    t22 = <>{t18}{t19}{t20}{t21}</>;
    $[87] = t18;
    $[88] = t19;
    $[89] = t20;
    $[90] = t21;
    $[91] = t22;
  } else {
    t22 = $[91];
  }
  return t22;
};
interface BulkOperationDropdownProps {
  operation_type: BulkOperationType;
  model?: BulkOperationModel;
  filters: BulkOperationFilters;
  onSubmit?: () => void;
  filterHistory?: boolean;
}
const BulkOperationDropdown: React.FC<BulkOperationDropdownProps> = t0 => {
  const $ = _c(32);
  const {
    operation_type,
    model,
    filters,
    onSubmit,
    filterHistory: t1
  } = t0;
  const filterHistory = t1 === undefined ? false : t1;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const config = BULK_OPERATION_CONFIGS[operation_type];
  let t2;
  if ($[0] !== model || $[1] !== operation_type) {
    t2 = getOperationLabels(operation_type, model);
    $[0] = model;
    $[1] = operation_type;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const labels = t2;
  let t3;
  if ($[3] !== model || $[4] !== operation_type) {
    t3 = getApiMethod(operation_type, model);
    $[3] = model;
    $[4] = operation_type;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const api_method = t3;
  let t4;
  if ($[6] !== api_method || $[7] !== config.count_api_key || $[8] !== operation_type) {
    t4 = () => {
      if (operation_type === "cancel") {
        return APIMethodKeys.bulk.cancelEvents;
      }
      return APIMethodKeys[config.count_api_key][api_method];
    };
    $[6] = api_method;
    $[7] = config.count_api_key;
    $[8] = operation_type;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const getApiMethodKey = t4;
  let t5;
  if ($[10] !== getApiMethodKey || $[11] !== operation_type) {
    t5 = operation_type === "cancel" ? APIMethodKeys.bulk.cancelEvents.list({
      in_progress: true
    }) : getApiMethodKey().count({
      in_progress: true
    });
    $[10] = getApiMethodKey;
    $[11] = operation_type;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== HookdeckAPI || $[14] !== api_method || $[15] !== config.count_api_key || $[16] !== operation_type) {
    t6 = () => {
      let api_call;
      if (operation_type === "cancel") {
        api_call = HookdeckAPI.bulk.cancelEvents.list({
          in_progress: true
        });
      } else {
        api_call = HookdeckAPI[config.count_api_key][api_method].count({
          in_progress: true
        });
      }
      if (operation_type === "cancel") {
        return api_call.then(_temp6);
      }
      return api_call;
    };
    $[13] = HookdeckAPI;
    $[14] = api_method;
    $[15] = config.count_api_key;
    $[16] = operation_type;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  const {
    data: ongoing_count
  } = useSWR(t5, t6);
  const t7 = config.icon as any;
  let t8;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      min: 624,
      max: 624
    };
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== ongoing_count) {
    t9 = ongoing_count && ongoing_count.count > 0 ? {
      label: String(ongoing_count.count)
    } : undefined;
    $[19] = ongoing_count;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== filterHistory || $[22] !== filters || $[23] !== model || $[24] !== onSubmit || $[25] !== operation_type) {
    t10 = <ErrorBoundary><DropdownContent operation_type={operation_type} model={model} filters={filters} onSubmit={onSubmit} filterHistory={filterHistory} /></ErrorBoundary>;
    $[21] = filterHistory;
    $[22] = filters;
    $[23] = model;
    $[24] = onSubmit;
    $[25] = operation_type;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== labels.label || $[28] !== t10 || $[29] !== t7 || $[30] !== t9) {
    t11 = <Dropdown icon={t7} outline={true} parent_width={t8} label={labels.label} expand_icon="chevron_down" portal={true} badge={t9}>{t10}</Dropdown>;
    $[27] = labels.label;
    $[28] = t10;
    $[29] = t7;
    $[30] = t9;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  return t11;
};
export default BulkOperationDropdown;
function _temp(op) {
  return op.in_progress;
}
function _temp2(list) {
  return {
    count: list.models.filter(_temp).length
  };
}
function _temp3(op_0) {
  return !op_0.in_progress;
}
function _temp4(list_0) {
  return {
    count: list_0.models.filter(_temp3).length
  };
}
function _temp5(op) {
  return op.in_progress;
}
function _temp6(list) {
  return {
    count: list.models.filter(_temp5).length
  };
}